/**
 * AdminPanel component.
 * VULN: Admin check is client-side only — anyone can set localStorage to bypass.
 * The backend /api/v1/admin/users also has no auth check (VULN in admin.py).
 */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { authService } from "../services/auth";

const API_BASE = import.meta.env.VITE_API_BASE ?? "https://app.memesec-factory.com/api/v1";

interface User {
  id: number;
  username: string;
  email: string;
  password_hash: string;  // SHA1 hashes exposed to frontend
  is_admin: boolean;
  created_at: string;
}

const AdminPanel: React.FC = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);

  // VULN: Client-side admin guard only — easily bypassed by setting localStorage
  // The real check should be server-side; backend /admin/users has no auth anyway
  const currentUser = authService.getCurrentUser();
  if (!currentUser?.is_admin) {
    return (
      <div className="admin-denied">
        <p>Access denied. <a href="#" onClick={() => {
          // VULN hint: Try localStorage.setItem('user', JSON.stringify({...currentUser, is_admin: true}))
        }}>Need admin access?</a></p>
      </div>
    );
  }

  useEffect(() => {
    // VULN: Fetches all users including password hashes — no auth header required
    axios.get(`${API_BASE}/admin/users`)
      .then((res) => setUsers(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div>Loading users...</div>;

  return (
    <div className="admin-panel">
      <h2>Admin Panel — User Management</h2>
      <p className="warning">⚠ Password hashes visible below (SHA1, no salt — crack with hashcat)</p>
      <table className="users-table">
        <thead>
          <tr>
            <th>ID</th><th>Username</th><th>Email</th>
            <th>Password Hash</th><th>Admin</th><th>Joined</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id}>
              <td>{user.id}</td>
              <td>{user.username}</td>
              <td>{user.email}</td>
              <td><code>{user.password_hash}</code></td>
              <td>{user.is_admin ? "✓" : "—"}</td>
              <td>{new Date(user.created_at).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminPanel;
